module.exports = __webpack_public_path__ + "static/mobile-calendar2-7f9bc520c4717ceb8c5b4fd55bce5fc9.png";